import React from "react";
import AppSettingsLayout from "../../../layouts/admin/settings/settings.layout";

const AppSettingsPage = () => {
  return <AppSettingsLayout />;
};

export default AppSettingsPage;
